import { render, staticRenderFns } from "./Arecommendations.vue?vue&type=template&id=c4a0cf38"
import script from "./Arecommendations.vue?vue&type=script&lang=js"
export * from "./Arecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports